import classNames from "classnames";
import Link from "next/link";
import styles from "./index.module.less";

export default function HBTab({
  tabs,
  className,
  divider = true,
  currentTab,
  onChange,
  align = "center",
  style = null,
}: {
  currentTab: string;
  tabs: {
    key: string;
    title: string;
    href: string;
    onClick?: (tab: { key: string; title: string }) => void;
  }[];
  className?: string;
  divider: boolean;
  onChange?: (tab: string) => void;
  align?: "center" | "left" | "right";
  style?: Record<string, number | string>;
}) {
  return (
    <div className={classNames(styles.tabContainer, className)} style={style}>
      <div className={styles.tabButtons} style={{ justifyContent: align }}>
        {tabs.map(({ key, title, href, onClick }) => {
          if (href) {
            return (
              <Link key={key} href={href} passHref>
                <a
                  data-gd-click="button_click"
                  data-button-name={title}
                  className={classNames(styles.tabButton, {
                    [styles.current]: currentTab === key,
                  })}
                >
                  {title}
                </a>
              </Link>
            );
          }
          return (
            <a
              key={key}
              data-gd-click="button_click"
              data-button-name={title}
              className={classNames(styles.tabButton, {
                [styles.current]: currentTab === key,
              })}
              onClick={() => {
                onClick?.({ key, title });
              }}
            >
              {title}
            </a>
          );
        })}
      </div>

      {/* 分割线 */}
      {divider && <div className={styles.divider} />}
    </div>
  );
}
